import { memo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useGetSummaryCartQuery } from 'services/ecommerceApi';
import { sessionSelectors } from 'store/state/selectors';
import { useTranslation } from 'react-i18next';
import * as S from './styles';

function CartButton() {
  const navigate = useNavigate();
  const { producerUrl } = useSelector(sessionSelectors.getRoot);
  const selectedCustomerId = useSelector(
    sessionSelectors.getSelectedCustomerId,
  );

  const { t } = useTranslation('translation', { keyPrefix: 'header' });

  const { data: summaryCart } = useGetSummaryCartQuery(
    { customerId: selectedCustomerId },
    { skip: !selectedCustomerId },
  );

  return (
    <S.CartButton
      count={summaryCart?.totalItems || 0}
      onClick={() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        navigate(`/${producerUrl}/shopping-cart`);
      }}
    >
      <S.ShoppingCartOutlined />
      <S.Text>{t('cart')}</S.Text>
    </S.CartButton>
  );
}

export default memo(CartButton);
